import { render } from "./ProfileFieldsForm.vue?vue&type=template&id=526b21ff"
import script from "./ProfileFieldsForm.vue?vue&type=script&lang=js"
export * from "./ProfileFieldsForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/survey-cms/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__